module.exports = __webpack_public_path__ + "static/img/metal12.5db6cd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/metal12.jpg
// module id = +J/h
// module chunks = 0